
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CountryResource,
} from '../models';
import {
    CountryResourceFromJSON,
    CountryResourceToJSON,
} from '../models';

export interface GetAvailableCountriesRequest {
    filtered?: boolean;
}

/**
 * 
 */
export class ComplianceCountriesApi extends runtime.BaseAPI {

    /**
          */
    async getAvailableCountriesRaw(requestParameters: GetAvailableCountriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResource>>> {
        const queryParameters: any = {};

        if (requestParameters['filtered'] != null) {
            queryParameters['filtered'] = requestParameters['filtered'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResource>>({
            path: `/compliance/api/countries/available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResourceFromJSON);
        return response;
    }

    /**
          */
    async getAvailableCountries(requestParameters: GetAvailableCountriesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResource>> {
        const response = await this.getAvailableCountriesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getBlockedCountriesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<CountryResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<CountryResource>>({
            path: `/compliance/api/countries/blocked`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(CountryResourceFromJSON);
        return response;
    }

    /**
          */
    async getBlockedCountries(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<CountryResource>> {
        const response = await this.getBlockedCountriesRaw(initOverrides);
        return response._data;
    }

}
